<div class="client-page-content">
  <div class="content-header" *ngIf="!deleted">
    <h2>{{ 'CLIENT.clientCancelBooking.wishToDelete' | translate }}</h2>
  </div>

  <div class="resume" *ngIf="!deleted">

    <p *ngIf="booking?.multipleBookings?.length">
      <ng-container *ngFor="let service of booking?.multipleBookings; let i = index">
        <strong>{{ service?.service?.name }}</strong> ({{ service.provider.name }})<span
          *ngIf="i < booking.multipleBookings.length - 1">, </span>
      </ng-container>
      <br />{{booking?.dateInit | dateFix | date:'longDate'}}, {{booking?.dateInit | dateFix | date : formatTime}}

    </p>

    <p *ngIf="!booking?.multipleBookings?.length">
      <strong>{{ booking?.service?.name }}</strong>
      <br />{{booking?.dateInit | dateFix | date:'longDate'}}, {{booking?.dateInit | dateFix | date : formatTime}} -
      {{booking?.dateEnd | dateFix | date : formatTime}}
      <br /><span *ngIf="booking?.provider?.name">{{ booking?.provider?.name }}</span>
    </p>

    <br/>
  </div>

  <div class="success" *ngIf="deleted">
    <div class="ico">
      <i class="material-icons icon">check</i>
    </div>
    <p class="mt-2">{{ 'CLIENT.clientCancelBooking.cancelledWithSuccess' | translate }}</p>
    <!-- <p class="edit-msg">Pode alterar ou cancelar a sua marcação a qualquer momento através do link no seu e-mail.</p> -->
  </div>
  <app-alert type="danger" [msg]="errorMsg"></app-alert>
</div>

<button *ngIf="!deleted" [disabled]="loading" class="btn btn-lg btn-danger w100 mt-2" (click)="cancelBooking()">{{ 'CLIENT.clientCancelBooking.ctaCancelBooking' | translate }}</button>
<a *ngIf="deleted" class="btn btn-lg btn-secondary w100 mt-2"  routerLink="../../../">{{ 'CLIENT.clientCancelBooking.ctaNewBooking' | translate }}</a>
